import { AloftPrice } from '@aloft/toolkit-shared';

import { applyRoundingAndThresholds } from '../../../redux/features/selectors/adjustmentSelectors/utils/applyRoundingAndThresholds.ts';
import { selectAdjustmentSettings } from '../../../redux/features/selectors/orderSelectors.ts';

// This formats the market adjusted sale price that was calculated from form
// values for display within the form.
// We need to respect rounding settings here (see TKE-1369).
export const getMarketAdjustedSalePriceDisplay = (
  marketAdjustedSalePrice: AloftPrice,
  settings: ReturnType<typeof selectAdjustmentSettings>,
): string => {
  const applied =
    applyRoundingAndThresholds(marketAdjustedSalePrice, 'dateOfSale', settings) ?? AloftPrice.zero;
  return applied.toString(true);
};
